import { gql } from '@apollo/client';

export const GET_SHARED_BY_ME = gql`
  query sharedByMe($limit: Int) {
    sharedByMe(limit: $limit) {
      storyId
      title
      sharers {
        username
        avatarInitials
        avatarUrl
      }
      circles
      sharedAt
      isRead
      readAt
      contributorCount
      readMinutes
      storyUrl
    }
  }
`;
